import {baseApi} from 'core/redux/store/api';
import {API_VERSION} from 'core/helpers/env';

export const abTestService = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getABTest: builder.query({
            query: ({abTestName}: {abTestName: string}) => ({
                url: `${API_VERSION}/ab-test/init/${abTestName}`,
                method: 'POST',
            }),
            transformResponse: (response: Record<string, string>) => response,
        }),
    }),
});

export const {getABTest} = abTestService.endpoints;

export const {
    useGetABTestQuery,
    util: {getRunningQueriesThunk: getAbTestRunningQueriesThunk},
} = abTestService;
